<template>
  <div class='CardTopUp'>
    <div class="queryCard">
      <div class="header">
        <div class="queryItem">
          <span>账号： </span>
          <el-input v-model="queryCard.cardNo" 
                    clearable
                    size="small"></el-input>
        </div>
        <div class="queryItem">
          <span>账户类型： </span>
          <el-select  v-model="queryCard.cardTypeId" placeholder="" clearable size="small">
            <el-option
              v-for="item in cartTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="queryItem">
          <span>会员ID： </span>
          <el-input v-model.trim="queryCard.bindAccount"
                    clearable
                    size="small"></el-input>
        </div>
        <div class="queryItem">
          <span>账号名称： </span>
          <el-input v-model.trim="queryCard.bindAccountName"
                    clearable
                    size="small"></el-input>
        </div>
        <!-- <div class="queryItem">
          <span>卡种类： </span>
          <el-select v-model="queryCard.cardNature" placeholder="" clearable size="small">
            <el-option
              v-for="item in cardNatureOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div> -->
        <div class="queryItem">

          <el-button type="primary"
                     size="medium"
                     @click="()=>queryCardList(true)">查询</el-button>
          <el-button size="medium"
                     @click="searchResetForm">重置</el-button>
        </div>

      </div>

      <Table :TableParam="Table"
             v-if="Table.data.length > 0"
             class="table">
            <template v-slot:Paging>
            <Paging @change="queryCardList"
                :pager="pager" />
          </template>
            </Table>
    </div>
    <div class="topUp">
      <p class="selectCount">已选：{{multipleSelection.length}}张</p>

      <el-form label-width="100px"
               class="demo-ruleForm">
        <el-form-item label="充值金额"
                      class="topUpMoneyInput"
                      prop="name">
          <el-input v-model="topUpMoney"></el-input>
        </el-form-item>
      </el-form>

      <el-button type="primary"
                 class="topUpBtn"
                 size="medium"
                 @click="rechargeCard">充值</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Table from '@/components/Table'
import Paging from '@/components/Paging'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },
      queryCard: {},
      Table: { // 表格
        // maxHeight:500,
        selectionHandle: (val, el) => this.handleSelectionChange(val, el),
        isHeader: false,
        data: [],
        el: null,
        column: [
          { type: 'selection' },
          { prop: 'cardNo', label: '账号' },
          { prop: 'remaining', label: '金额' },
          { prop: 'cardTypeName', label: '账号类型' },
          { prop: 'bindAccountName', label: '账号名称' },
          { prop: 'bindAccount', label: '会员ID' },
        ]
      },
      multipleSelection: [], // 选中的列
      topUpMoney: null,
      cartTypeList: [],
      cardNatureOptions: [
            // {name:'定额卡', id:0},
            {name:'不定额卡', id:1},
            {name:'动态充值卡', id:2},
          ],
    cardNatureObj:{
        0: '定额卡',
        1: '不定额卡',
        2: '动态充值卡'
      },
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {

    // 点击重置按钮
    searchResetForm () {
      this.queryCard = {}
    },

    handleSelectionChange (val, el) {
      if (!this.Table.el) {
        this.Table.el = el
      }
      this.multipleSelection = val
    },

    queryCardList (flag) {
      const { pager } = this
      const param = {
        ...this.queryCard,
        pageNum: pager.page,
        pageSize: pager.rows,
        rechargedTable: true,
        cardNature: 2
      }
      this.$http.getCardPagination(param)
        .then((res) => {
          if (res.status === 200) {
            this.pager.count = res.data.total
            this.Table.data = res.data.list.map(item=>{
              return{
                ...item,
                cardNatureName: this.cardNatureObj[item.cardNature]
              }
            })
            flag && this.$message.success(res.msg)
          } else {
            flag && this.$message.error(res.msg)
          }
        })
    },
    // 点击充值按钮并发送充值请求
    rechargeCard () {
      if (!this.judgeTopUpMoney()) return
      const ids = this.multipleSelection.map(item => item.id)
      const param = {
        amount: this.topUpMoney,
        ids
      }
      this.$http.rechargeCard(param)
        .then((res) => {
          if (res.status === 200) {
            this.queryCardList()
            this.Table.el.clearSelection()
            this.topUpMoney = null
            this.$message.success(res.msg)
          }
        })
    },

    judgeTopUpMoney () {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请最少选择一张卡')
        return
      }
      // if (!this.topUpMoney || this.topUpMoney < 0 || String(this.topUpMoney).indexOf('.') !== -1) {
      //   this.$message.error('请输入大于0的整数')
      //   return false
      // }
      if (!this.topUpMoney || isNaN(Number(''+this.topUpMoney))) {
        this.$message.error('请输入整数')
        return false
      }
      if(!isNaN(Number(''+this.topUpMoney))){
        if(!/^([-?[0-9]{0,4}|[0-9])+.?[0-9]{0,2}$/.test(Number(this.topUpMoney))){
          this.$message.error('最多两位小数!')
          return false
        }
      }
      return true
    },
    // 卡类型
    getCardTypeList () {
      this.$http.getCardTypeList()
        .then((res) => {
          if (res.status === 200) {
            this.cartTypeList = res.data
          }
        })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getCardTypeList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.CardTopUp {
  display: flex;
  flex-direction: row !important;
  padding: 0 20px;
  margin-top: 20px;
  .queryCard {
    width: 60%;
    height: 100%;
    background-color: #fff;
    border-radius: 10px;
    .header {
      padding: 0 50px;
      margin-top: 30px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      ::v-deep.el-input__inner{
        width:219.52px;
      }
      .queryItem {
        width: 45%;
        max-width: 300px;
        display: flex;
        margin-top: 20px;
        span {
          display: inline-block;
          width: 110px;
          line-height: 32px;
          color: #555;
        }
      }
    }
    .table {
      margin-top: 40px;
    }
  }
  .topUp {
    width: 40%;
    height: 100%;
    margin-left: 20px;
    background-color: #fff;
    border-radius: 10px;
    text-align: center;
    .selectCount {
      padding: 80px 0 0 20px;
      font-style: italic;
      font-weight: 500;
      text-align: left;
    }

    .topUpMoneyInput {
      width: 60%;
      margin: 50px 0 0 30px;
    }

    .topUpBtn {
      margin-top: 100px;
    }
  }
}
</style>
